import FullScreenLoader from './FullScreenLoader.jsx';

export default FullScreenLoader;